import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import SummaryTablesTop50 from "../components/SOD/SummaryTables/SummaryTablesTop50";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string) => {
      dispatch(actions.updateFilter(filterField, value));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SummaryTablesTop50);
